import { createContext, useContext, useReducer } from "react";
import { inventorySearchReducer } from "./reducer";

export const SELECT_AN_ACCOUNT = "Select an account";
export const NO_ACCOUNT = { id: "", businessName: SELECT_AN_ACCOUNT };

const initState = {
  currentInventory: {},
  selectedInventoryItem: null,
  origInventoryItem: null,
  areas: null,
  zones: null,
  selectedArea: null,
  selectedZone: null,
  selectedAisle: null,
  selectedLocation: null,
  selectedLocationInventories: [],
  bayList: [],
  showCapacityDisplay: false,
  dbInventories: [],
  searchInventories: [],
  allAccounts: [NO_ACCOUNT],
  selectedAccount: NO_ACCOUNT,
  searchTerm: "",
  searchInventoryItemsMap: [],
  showInventoryQuantity: false,
  loading: true,
  searchAisles: [],
  scannedBarcode: "",
  updatedAt: null,
};

const InventorySearchContext = createContext(initState);
export const InventorySearchProvider = ({ children }) => {
  const [state, dispatch] = useReducer(inventorySearchReducer, initState);

  return (
    <InventorySearchContext.Provider value={{ state, dispatch }}>
      {children}
    </InventorySearchContext.Provider>
  );
};
export const useInventorySearchContext = () =>
  useContext(InventorySearchContext);
